import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressRouterModule } from 'ngx-progressbar/router';

import { tokenGetter } from '@shared/authorization.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PipesModule } from './pipes/pipes.module';

import { HeaderIphoneDirective } from './iphone-fix-directives/header-iphone.directive';
import { HeaderArrowDirective } from './iphone-fix-directives/header-arrow.directive';
import { LogoutPositionDirective } from './iphone-fix-directives/logout-position.directive';
import { SidebarIphoneDirective } from './iphone-fix-directives/sidebar-iphone.directive';
import { ContentFixDirective } from './iphone-fix-directives/content-fix.directive';
import { SharedModule } from '@shared/shared.module';
import { MantisSharedModule } from './theme/mantis-shared/shared.module';
import { ProfileModule } from './profile/profile.module';
import { OfflineInterceptor } from '@shared/interceptors/offline.interceptor';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule, SERVICE_WORKER, VAPID_KEY } from '@angular/fire/compat/messaging';
import { environment } from '@environments/environment';
import { NotificationMessageComponent } from './notification-message/notification-message.component';
// Removed @ngx-translate imports - using existing TranslationService instead

@NgModule({ declarations: [
        AppComponent,
        HeaderIphoneDirective,
        HeaderArrowDirective,
        ContentFixDirective,
        LogoutPositionDirective,
        SidebarIphoneDirective,
        NotificationMessageComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        AppRoutingModule,
        ProfileModule,
        JwtModule.forRoot({
            config: {
                tokenGetter,
                allowedDomains: [
                    'localhost',
                    'fitness-marketplace.test:8083',
                    'api.leanondigital.me',
                    'api.leanondigital.com'
                ],
            }
        }),
        SharedModule,
        MantisSharedModule,
        PipesModule,
        // Removed TranslateModule - using existing TranslationService and TranslatePipe
        BsDropdownModule.forRoot(),
        AccordionModule.forRoot(),
        NgProgressModule,
        NgProgressRouterModule,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFireMessagingModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: OfflineInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        ...(environment.firebaseVapidKey
            ? [{ provide: VAPID_KEY, useValue: environment.firebaseVapidKey }]
            : []),
        {
            provide: SERVICE_WORKER,
            useFactory: () => {
                if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
                    return undefined;
                }

                return navigator.serviceWorker.ready;
            },
        },
    ] })
export class AppModule { }


